module.exports = __webpack_public_path__ + "img/empty.77f52ac6.png";